<template>
<div class="shopee-preview">
<div class="lzd-preview__content">
  <div class="lzd-preview__viewer" :style="{backgroundImage: 'url(\''+img.url+'\')'}" ></div>
</div>
<div class="lzd-preview__footer">
  <button type="button" @click="cancel()" class="im-components-btn im-components-btn-normal im-components-btn-medium">取消</button>
  <button type="button" @click="confirm()" class="im-components-btn im-components-btn-primary im-components-btn-medium">确定</button>
</div>
</div>
</template>
<script>
import EventBus from "@/utils/eventBus";
import MsgUtils from '@/utils/MsgUtils';

export default {
  data() {
    return {
      // 默认选中的值
      icon: "ios-square-outline"
    };
  },
  created() {
  },
  props: ["img"],
  computed: {
    currentSession: {
      get: function() {
        let shop_id = this.$store.state.shopee.currentStore.shop_id;
        return this.$store.state.shopee.currentSessionData[shop_id];
      }
    },
    currentStore: {
      get: function () {
        return this.$store.state.shopee.currentStore;
      }
    }
  },
  methods: {
    cancel() {
      this.$emit('previewhide');
    },
    confirm() {
      let param = new FormData();
      param.set("store_id", this.currentStore.id);
      param.set("to_id", this.currentSession.to_id);
      param.set("message_type", 'image');
      param.set("image_url", this.img.url);

      MsgUtils.request(this, param).then(() => {
        EventBus.$emit('shopeeAddmsgCallback');
      })
      this.$emit('previewhide');
    }
  }
};
</script>
<style lang="scss">
@import "@/static/styles/theme";

.shopee-preview {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  flex-direction: column;
  background-color: rgba(0,0,0,.7);
  z-index: 9999999999!important;
  display: flex;

  .lzd-preview__content {
    flex: 1 1;
    display: flex;
    padding: 30px;

    .lzd-preview__viewer {
      transform: scale(1);
      flex: 1 1;
      background-repeat: no-repeat;
      background-position: 50%;
      background-size: auto,contain;
    }
  }
  .lzd-preview__footer {
    text-align: center;
    justify-content: center;
    background-color: rgba(0,0,0,.5);
    padding: 60px 50px;

    .im-components-btn {
      position: relative;
    display: inline-block;
    font-style: normal;
    font-family: inherit;
    background: transparent;
    cursor: pointer;
    box-shadow: none;
    border-radius: 3px;
    text-align: center;
    height: 28px;
    padding: 0 16px;
    font-size: 14px;
    line-height: 26px;
    border-width: 1px;
    }
    .im-components-btn-normal {
      border-style: solid;
      background-color: #f7f8fa;
      border-color: #c4c6cf;
    }
    .im-components-btn-primary {
      background-color: #0898ff;
      margin: 0 15px;
    }
  }
}
</style>
